// matchMedia fails when media query is prepended with @media
export const parseMediaQueryForMatchMedia = (mediaQuery: string) => {
  return mediaQuery.replace('@media', '').trim();
};
